<template>
  <div class="loginInputWrapper">
    <small>{{spanText}}</small>
    <div class="loginInputFileWrapper">
      <button class="regCertBtn" v-on:click="openSignUpRegCertModal">추가</button>
      <span class="fileName">{{fileName}}</span>
    </div>
  </div>
</template>

<script>
import signUpCertificateRegistrationModal from './signUpCertificateRegistrationModal'

export default {
  components: {
    'cert-reg': signUpCertificateRegistrationModal
  },
  data () {
    return {
      fileName: ''
    }
  },
  props: {
    spanText: String
  },
  methods: {
    openSignUpRegCertModal: function () {
      this.$emit('openSignUpRegCertModal')
    }
  },
  mounted: function () {
    this.$store.watch(() => this.$store.getters.getSignUpCertFileInfoFlag, value => {
      let info = this.$store.getters.getSignUpCertFileInfo
      this.fileName = info.fileName
      this.$emit('returnFileInfo', info.fileInfo)
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
small{
  color: rgb(0,153,255);
}

.regCertBtn {
  font-size: 13px;
  width: 104px;
  height: 40px;
  background-color: white;
  cursor: pointer;
  border: 1px solid black;
  outline: none;
}

.loginInputWrapper{
  font-size: 11px;
  margin-top: 25px;
}

.loginInputFileWrapper{
  width: 396px;
  padding-top: 25px;
  padding-bottom: 10px;
  font-size: 13px;
}

.loginInputFileWrapper > span{
  margin-left: 10px;
}

.inputFileHidden{
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip:rect(0,0,0,0);
  border: 0;
}

.validationMsgWrapper{
  font-size: 10px;
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/login/elements/loginInputFile.vue